<div class="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
  <div class="ps-3">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb mb-0 p-0">
        <li class="breadcrumb-item"><a href="javascript:;"><i class="bx bx-home-alt"></i></a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">USER ACCOUNTS</li>
      </ol>
    </nav>
  </div>
  <div class="ms-auto">
    <div class="btn-group">
      <button type="button" class="btn btn-primary" *ngIf="admin == 'true'" (click)="onAdd()">ADD USER</button>
    </div>
  </div>
</div>
<div class="card">
  <div class="card-body">
    <div class="d-flex align-items-center">
      <h5 class="mb-0"></h5>
      <form class="ms-auto position-relative">
        <div class="position-absolute top-50 translate-middle-y search-icon px-3"><i class="bi bi-search"></i></div>
        <input class="form-control ps-5" type="text" placeholder="search">
      </form>
    </div>
    <div class="table-responsive mt-3">
      <table class="table align-middle">
        <thead class="table-secondary">
          <tr>
            <th>NAME</th>
            <th>EMAIL</th>
            <th>PHONE</th>
            <th>ACTION</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let acc of users">
            <td>
              {{ acc.user.full_name }}
            </td>
            <td>{{ acc.user.email }}</td>
            <td>{{ acc.user.phone }}</td>
            <td>
              <div class="table-actions d-flex align-items-center gap-3 fs-6">
                <i class="bi bi-pencil-fill pencil text-primary" (click)="onUpdate(acc)"></i>
                <i class="bi person" [ngClass]="acc.state_class" *ngIf="admin == 'true'" (click)="onActivate(acc)"></i>
                <i class="bi bi-trash-fill trash text-danger" *ngIf="admin == 'true'"
                  (click)="onDelete(acc)"></i>&nbsp;&nbsp;
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
<nav aria-label="Page navigation example" class="pagination" *ngIf="totalItems > 0">
  <ul class="pagination">
    <li class="page-item" (click)="prev()"><a class="page-link" href="javascript:;">Previous</a>
    </li>
    <li class="page-item" *ngIf="pageNumber < 10"><a class="page-link" href="javascript:;">{{pageNumber + 1}}</a>
    </li>
    <li class="page-item" (click)="next()"><a class="page-link" href="javascript:;">Next</a>
    </li>
  </ul>
</nav>
<div class="modal fade" data-backdrop="static" data-keyboard="false" id="accountModal" tabindex="-1" role="dialog"
  aria-labelledby="accountModalabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">{{ modal_user.header }}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
          (click)="onModalClose('account')"></button>
      </div>
      <div class="form modal-body" [formGroup]="user_modal_form">
        <div class="row">
          <div class="col-md-6">
            <label class="form-label">Name</label>
            <div class="form-group">
              <input type="text" class="form-control" [class.invalid]="name.invalid && name.touched" formControlName="name"/>
              <div *ngIf="name.errors && name.invalid && name.touched">
                <small class="text-danger" *ngIf="name_errors['required']">Name is required</small>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <label class="form-label">Email</label>
            <div class="form-group">
              <input type="email" autocomplete="off" class="form-control" [class.is-invalid]="email.invalid && email.touched" 
              required formControlName="email"/>
              <div *ngIf="email.errors && email.invalid && email.touched">
                <small class="text-danger" *ngIf="email_errors['required']">Email is required</small>
                <small class="text-danger" *ngIf="email_errors['pattern']">Please provide a valid email address</small>
              </div>
            </div>
          </div>
        </div>
        <div class="row" style="margin-top: 2%;">
          <div class="col-md-6">
            <label class="form-label">Phone</label>
            <div class="form-group">
              <input type="text" autocomplete="off" class="form-control" [class.is-invalid]="phone.invalid && phone.touched"
              required formControlName="phone"/>
              <div *ngIf="phone.errors && phone.invalid && phone.touched">
                <small class="text-danger" *ngIf="phone_errors['required']">Phone number is required</small>
                <small class="text-danger" *ngIf="phone_errors['pattern']">Please provide a valid phone number</small>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <label class="form-label">Subscription Upto</label>
            <div class="input-group">
              <input type="date" autocomplete="off" class="form-control"
              formControlName="subscription_upto">
            </div>
          </div>
        </div>
        <div class="row" style="margin-top: 2%;" *ngIf="modal_user.mode == 'add'">
          <div class="col-md-6">
            <label class="form-label">Password</label>
            <div class="form-group">
              <input type="password" class="form-control" formControlName="password">
              <div *ngIf="password.errors && password.invalid && password.touched">
                <small class="text-danger" *ngIf="password_errors['required']">Password is required</small>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-danger btn-block" data-dismiss="modal" (click)="onModalClose('account')">
          CANCEL
        </button>
        <button class="btn btn-primary" (click)="saveUser()" [disabled]="user_modal_form.invalid">
          {{ modal_user.btn_text }}
        </button>
      </div>
    </div>
  </div>
</div>
<div class="modal fade" id="confirmationModal" tabindex="-1" role="dialog" aria-labelledby="confirmationModallabel"
  aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="confirmationModalLabel">ALERT</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
          (click)="onModalClose('confirmation')"></button>
      </div>
      <div class="modal-body px-5">
        <div class="row">
          <div class="col-md-12">
            <span class="fs-15"> {{ cm_params.msg }}
              <b>{{ cm_params.tag }}</b></span>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-primary btn-block" data-dismiss="modal" (click)="onModalClose('confirmation')">
          CANCEL
        </button>
        <button class="btn btn-danger btn-block" [ngClass]="cm_params.btn_class" (click)="onConfirm()">
          {{ cm_params.btn_text }}
        </button>
      </div>
    </div>
  </div>
</div>